































import { Component, Vue, Prop } from 'vue-property-decorator';

@Component
export default class SSelectOption<ValueType, Option> extends Vue {
  @Prop({ type: String, required: true }) public label!: string;
  @Prop(String) public detail?: string;
  @Prop(Boolean) public multiple!: boolean;
  @Prop(Boolean) public selected!: boolean;
  @Prop(Boolean) public focused!: boolean;
}
